<template>
    <div class="message-item--event"
        :id="id">
        <div class="content-wrap">
            <slot name="prefix"></slot>
            <p class="event" :style="{'--color': color}">{{content}}</p>
            <slot name="suffix"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageEvent',
        props: {
            baseProps: {
                type: Object,
                required: true
            },
            content: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            }
        },
        computed: {
            id () {
                return this.baseProps['id']
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return '#999'
                }
                return this.$store.state.lingkeColor
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;

        > :first-child:not(.event) {
            margin-right: 3px;
        }

        > :last-child:not(.event) {
            margin-left: 5px;
        }
    }

    .event {
        color: var(--color);
        font-size: 12px;
        line-height: (18 / 12);
        text-align: center;
        margin: -3px 0;
    }

    .event__icon {
        font-size: 12px;
        color: #B7B7B7;

        &.icon_close {
            font-size: 9px;
        }
    }
</style>
